import { SubscriptionBillingCodeField, SubscriptionNameFields } from './FormFields';

/**
 * Conditional field groups for subscription forms
 * These components show different fields based on whether the user has a billing code
 */

interface BillingCodeFieldGroupProps {
    dataMetrics?: string;
    value?: string;
    readOnly?: boolean;
}

/**
 * Field group shown when user selects "Yes" for having a billing code
 * Displays only the billing association code field
 */
export const BillingCodeFieldGroup = (props: BillingCodeFieldGroupProps) => {
    return <SubscriptionBillingCodeField {...props} />;
};

interface TrialUserFieldGroupProps {
    firstNameDataMetrics?: string;
    lastNameDataMetrics?: string;
}

/**
 * Field group shown when user selects "No" for having a billing code
 * Displays first name and last name fields for trial users
 */
export const TrialUserFieldGroup = (props: TrialUserFieldGroupProps) => {
    return <SubscriptionNameFields {...props} />;
};
